import mapValues from 'lodash/mapValues';
import {API_DOMAIN} from './ApiService';
import routes from './routes.json';

const api = mapValues(routes, (value) => API_DOMAIN + value);

export default api;
